import { BaseHelper } from 'services/BaseGraphQLAPIHelper';
import { getInFilterValue } from 'utils';

export const getMerchantRecordList = (afterCursor = '', search) => {
  let searchString = `, orderBy: "${search.rank ? '-pk' : 'pk'}"`;
  if (search?.sort) {
    searchString = `, orderBy: "${search?.sort}"`;
  }
  if (search?.creationDateGte) {
    searchString += `, creationDateGte: "${search.creationDateGte}"`;
  }
  if (search?.creationDateLte) {
    searchString += `, creationDateLte: "${search.creationDateLte}"`;
  }
  if (search.merchantAdminIn) {
    searchString += `, merchantAdminIn: ${getInFilterValue(
      search.merchantAdminIn,
    )}`;
  }
  if (search.storeIn) {
    searchString += `, storeIn: ${getInFilterValue(search.storeIn)}`;
  }
  if (search.membershipIdIcontains) {
    searchString += `, membershipIdIcontains: "${search.membershipIdIcontains}"`;
  }

  const query = `
  {
    merchantUserRecords(
      first: 20,
      after: "${afterCursor}"${searchString}
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          pk
          recordType
          adjustRewardsType
          adjustRewardsAmount
          administrator {
            pk
            username
          }
          customer {
            pk
            membershipId
            isReset
            isTransferred
          }
          store {
            pk
            name
          }
          couponIds
          couponTemplate {
            pk
            couponType
          }
          cashDollar
          creationDate
        }
      }
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getMerchantRemarkOptions = (afterCursor = '') => {
  let searchString = `, orderBy: "pk"`;

  const query = `
  {
    adminRemarkTemplates(
      first: 100,
      after: "${afterCursor}"${searchString}
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          pk
          optionName
        }
      }
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const createMerchantRemarkOption = (remarkOption) => { 
  const query = `
  mutation CreateAdminRemarkTemplate($input: CreateAdminRemarkTemplateInput!) {
    createAdminRemarkTemplate(input: $input) {
      errors {
        field
        messages
      }
    }
  }`;
  const variables = {
    input: {
      ...remarkOption,
    },
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const updateMerchantRemarkOption = (remarkOption) => {
  const query = `
  mutation UpdateAdminRemarkTemplate($input: UpdateAdminRemarkTemplateInput!) {
    updateAdminRemarkTemplate(input: $input) {
      errors {
        field
        messages
      }
    }
  }`;
  const variables = {
    input: {
      ...remarkOption,
    },
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const deleteMerchantRemarkOption = (inputBody) => {
  const query = `
  mutation DeleteAdminRemarkTemplates($input: DeleteAdminRemarkTemplatesInput!) {
    deleteAdminRemarkTemplates(input: $input) {
      errors {
        field
        messages
      }
    }
  }`;
  const variables = {
    input: {
      ...inputBody,
    },
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

